import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateOrderFOBActions } from "store/ducks/ordersFob";

export function* updateOrderFOBRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateOrderFOBActions.success(data));
    notify("success", "Ordem atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateOrderFOBActions.failure(errorMessage));
  }
}
